<template>
  <div class="action-bar">
      <slot></slot>
 </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
.action-bar {
  z-index: 999;
  position: fixed;
  right: 50px;
  bottom: 25px;
  display:flex;
  flex-direction: row;
  align-items: center;

  // background-color: white;
  // color: white;
  // border: 1px solid rgb(161, 161, 161);
  // border-radius: 5px;
  // box-shadow: $boxShadow;
  // text-align: center;
  // line-height: 30px;
  // color: #1989fa;
  padding: 5px 0px;
  div {
    margin: 5px 5px;
  }
}
</style>
